import apiCommons from "../config/api_commons";
import getHeaders from "./getHeaders";

export function findAllCurrenciesConversions() {
  return apiCommons.get(
    "/bovexo/currencies/conversions",
    getHeaders(false, null)
  );
}
